import React from 'react'
import ServicesPage from "./common/ServicesPage";
import { Heading } from "@chakra-ui/react";
const RenovationServices = () => {
  return (
    <div>
      <ServicesPage

        title={
                <Heading
                  as="h1"
                  textAlign="center"                     // Center text
                  px={{ base: 4, md: 8 }}               // Responsive horizontal padding
                  fontSize={{ base: "xl", md: "2xl" }} // Responsive font size
                  className="services-title"
                >
                Let's build something better together    </Heading>
              }
   
        image="/baner (3).png"
        description={
          <>
            <p>
              Our <strong>Renovation Services</strong> are designed to transform
              your space while maintaining structural integrity and aesthetic
              appeal. Whether you need a complete home makeover, office
              refurbishment, or selective upgrades, our skilled team ensures
              every detail is handled with precision and creativity.
            </p>

            <p style={{ marginTop: "1rem" }}>
              From modern designs to traditional finishes, we work closely with
              you to bring your vision to life. Using high-quality materials and
              the latest techniques, we guarantee durability and style. Our team
              also takes care of plumbing, electrical, painting, flooring, and
              carpentry needs—making your renovation completely hassle-free.
            </p>

            <ul style={{ marginTop: "1rem", paddingLeft: "1.2rem",  }}>
              <li> Full home and office renovations</li>
              <li> Kitchen and bathroom remodeling</li>
              <li> Flooring, painting & interior upgrades</li>
              <li> Energy-efficient and eco-friendly solutions</li>
            </ul>

            <p style={{ marginTop: "1rem" }}>
              Choosing our renovation services means investing in functionality,
              comfort, and beauty. We don’t just renovate—we reinvent your space
              to reflect your lifestyle and future needs.
            </p>
          </>
        }
      />
    </div>
  )
}

export default RenovationServices
